import { useState, useEffect, useRef } from "react";
import EVENTS_API from "Services/EventAPI";
import PopupReserve from "Components/PopupReserve";
import PopupInfo from "Components/PopupInfo";
import PopupFreeCode from "Components/PopupFreeCode";
import {getCookie, formatMoney} from "Services/utils";
import {localeDatetime} from "Services/utils";
import {ReactComponent as CalendarSVG}  from "assets/icons/calendar.svg";
import {ReactComponent as ClockSVG}  from "assets/icons/clock.svg";
import {ReactComponent as UserGroupSVG}  from "assets/icons/user-group.svg";
import {ReactComponent as InfoSVG}  from "assets/icons/info.svg";
import {ReactComponent as CloseSVG}  from "assets/icons/close-x.svg";
import { useTranslation } from "react-i18next";
import LetterGif from 'assets/images/mail-animation.gif';

const POPUPI_NFO = {
    name: "popupInfo"
}

const EventList = () => {
    const [filtredEvents, setFiltredEvents] = useState(null);
    const [code, setCode] = useState(document.getElementById('ReactBooking')?.getAttribute("data-code") ?? "");
    const [codeError, setCodeError] = useState("");
    const [ticket, setTicket] = useState(null);
    const [codeData, setCodeData] = useState(null);
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const popupBtnRef = useRef(null);
    const popupFreeCodeBtnRef = useRef(null);
    const { t } = useTranslation();
    const language = document.getElementById('ReactBooking')?.getAttribute("data-lang") ?? "en";
    const scid = getCookie('SCDCID') ?? null;
    const [sessionInfo, setSessionInfo] = useState(null);
    const [showDescription, setShowDescription] = useState(null);    
    
    const [buyNewCodeData, setBuyNewCodeData] = useState({isOpen: false});
    const [cancelCodeData, setCancelCodeData] = useState({isOpen: false});
    /* eslint-disable */
    useEffect(() => {
        const handleOutsideClick = (event) => {
            setShowDescription(null);
            event.stopPropagation();
            if (event.target.getAttribute('name') === POPUPI_NFO.name) {
                sessionInfo && closePopupInfo();
            }
            if (event.target.getAttribute('name') === 'popupBuyCodeOverlay') {
                setBuyNewCodeData({isOpen: false});
            }
            if (event.target.getAttribute('name') === 'popupCancelCodeOverlay') {
                setCancelCodeData({isOpen: false});
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        if (isMounted ) {
            handleSearchDateWithCode(null, !!code);
        }

        return () => { isMounted = false };
    }, [reload])

    //Check whether the event you took part in, starts soon & enable "participe" button
    useEffect(() => {
    if(ticket?.id && ticket?.eventDateId){
        const timer = setInterval(()=>{
            EVENTS_API.checkDateStartSoon({eventDateId: ticket.eventDateId, ticketId: ticket.id})
            .then((res)=>{
                if(res.data?.startSoon){
                    setTicket({...ticket, startSoon: true});
                }else{
                    setTicket({...ticket, startSoon: false});

                }
            }).catch((err)=>{
                console.log('response: ', err.response);
                console.log('err: ', err);
            })
        },60000);
            
        return () => clearTimeout(timer);
    }

    }, [ticket])
    /* eslint-enable */

    const closePopupInfo = (e, action) => {
        if (action === "close") {
            setSessionInfo(null);
            return;
        }
        setSessionInfo((prevInfo) => !prevInfo);
    }

    const handleOpenInfoPopup = (e, methodInfo) => {
        const link =  methodInfo?.link?.replace('{connect_code}', methodInfo?.code)?.replace('{connect_pin}', methodInfo?.pin);
        const info = {
            title: {i18N: "session"},
            txt: {i18N: "Klick on the link to join the session"},
            method: {i18N: "session.method", value: methodInfo?.name},
            link: {i18N: "session.link", value: link},
        }
        if (methodInfo?.code) {
            info.code = {i18N: "session.code", value: methodInfo?.code};
        }
        if (methodInfo?.pin) {
            info.pin = {i18N: "session.pin", value: methodInfo?.pin};
        }
        
        setSessionInfo({...info})
    }

    const openFreeCodePopup = (e, id) => {
        e?.preventDefault();
        popupFreeCodeBtnRef.current?.setAttribute('data-event', id);
        popupFreeCodeBtnRef.current?.click();
    }

    const handleSearchDateWithCode = (e = null, sendCode =  false) => {
        e?.preventDefault();
        let currentCode = code?.toLocaleUpperCase();
        const queryParams = {scid};
        if (sendCode) {
            if (!code && sendCode) {
                setCodeError('code.input.err.empty');
                return;
            }
            if (!currentCode.startsWith("MTC-")) {
                if (currentCode.startsWith("MTC") && currentCode.length > 3) {
                    // Insert "-" after "MTC"
                    currentCode = currentCode.slice(0, 3) + "-" + currentCode.slice(3);
                } else {
                    currentCode = "MTC-" + currentCode;
                }
            }

            queryParams.code = currentCode;
        }
        setIsLoading(true);
        EVENTS_API.getAllWithDates(queryParams)
        .then((res)=>{
            const pathname = window.location?.href;
            if (pathname && currentCode) {
		let pathnameL = pathname?.toLocaleLowerCase();    
                // pathname contains /online-event:
                let lastIndexA = pathnameL.lastIndexOf('/online-event');
                let lastIndexB = pathnameL.lastIndexOf('/onlineevent');
                if (lastIndexA !== -1)
                {
                    const newPathname = pathname?.substring(0, lastIndexA);
                    window.history?.replaceState(null, "", newPathname+"/online-event/"+currentCode);
                }
                else if (lastIndexB !== -1)
                {
                    const newPathname = pathname?.substring(0, lastIndexB);
                    window.history?.replaceState(null, "", newPathname+"/OnlineEvent/"+currentCode);
                }
                else
                {
                    window.history?.replaceState(null, "", pathname+"/online-event/"+currentCode);
                }
            }
            const {events, ticket, codeData} = res.data;
            ['Expired', 'Valid',  'Used'].includes(codeData?.state) && setCode(currentCode);

            
            const params = new URLSearchParams(window.location.search);
            
            const selectedEventId = parseInt(params.get('event-id'))
            //if the event-idurl query parameter is set put the event in the first position of list 
            if (selectedEventId && !isNaN(selectedEventId) && Number.isInteger(selectedEventId) && events.length > 0) {
                const index = events.findIndex(event => event.id === selectedEventId);

                if (index > -1) {
                    const [selectedEvent] = events.splice(index, 1);
                    if (selectedEvent?.webinarEventDates?.length > 0) {
                        selectedEvent.isShifted = true;
                        events.unshift(selectedEvent);
                    }
                }
            }
            setFiltredEvents(events);
            setTicket(ticket);
            setCodeData(codeData);
        }).catch((err)=>{
            console.log('response: ', err.response);
            console.log('err: ', err);
        }).finally(()=>{
            setCodeError('');
            setIsLoading(false);
        })
    }

    const handleCancelCode = (e) => {
        e?.preventDefault();
        setIsLoading(true);
        EVENTS_API.cancelTicket(ticket?.id, {language, code})
                        .then((res)=>{
                setCancelCodeData({...cancelCodeData, response: true})
                setReload(!reload);
                        }).catch((err)=>{
                setCancelCodeData({...cancelCodeData, err: "book.err.unkown.txt"})
                                console.log('response: ', err.response);
                                console.log('err: ', err);
                        }).finally(()=>{
                setIsLoading(false);
            })
    }

    const openShop = (e, shopUri) => {
        e?.stopPropagation();
        e?.preventDefault();
        window.open("https://www.miray-software.com"+shopUri, '_blank');
    }

    return <>
        <h1>{t("title")}</h1>
        <h3>{['Valid', 'Used'].includes(codeData?.state) ? t("book") : t("all") }</h3>
        <p>{['Valid', 'Used'].includes(codeData?.state) ? t("book.txt") : t("all.txt") }</p>

        <div className="wb-grid-container">
            <div className="wb-grid-item wb-grid-item-6">
                <h3 className="wb-mb-1">{t("code.input")}</h3>
                <p dangerouslySetInnerHTML={{__html:t("code.txt")}} />
                {
                    <form style={{display: "inline-block"}}>
                        <input
                            //autoFocus
                            className="wb-input"
                            id="eventCode"
                            disabled={['Valid', 'Used'].includes(codeData?.state)}
                            style={{marginRight: "5px"}}
                            type="text"
                            placeholder={t("code.input.hint")}
                            value={code}
                            onChange={(e) => {setCode(e.target.value)}}
                        />
                        {!['Valid', 'Used'].includes(codeData?.state) &&
                            <button
                                type="submit"
                                style={{height: "36px", position: "relative", top: "-0.5px"}}
                                className="wb-button-blue"
                                onClick={(e) => handleSearchDateWithCode(e, true)}
                                    
                            >{t("code.btn")}</button>
                        }
                    </form>
                }
                {['Valid', 'Used'].includes(codeData?.state) &&
                    <button
                        style={{color:"#7A7A7A", height: "36px",display: "inline-block", position: "relative", top: "-0.5px"}}
                        className="wb-btn-light-grey"
                        onClick={(e) => {
                            e?.stopPropagation();
                            e?.preventDefault();
                            setCode("");
                            setCodeData(null);
                            setFiltredEvents(null);
                            setSessionInfo(null);
                            const pathname = window.location?.href;
                            if (pathname) {
			                    let pathnameL = pathname?.toLocaleLowerCase();    
                                // pathname contains /online-event:
                                let lastIndexA = pathnameL.lastIndexOf('/online-event');
                                let lastIndexB = pathnameL.lastIndexOf('/onlineevent');
                                if (lastIndexA !== -1)
                                {
                                    const newPathname = pathname?.substring(0, lastIndexA);
                                    window.history?.replaceState(null, "", newPathname+"/online-event");
                                }
                                else if (lastIndexB !== -1)
                                {
                                    const newPathname = pathname?.substring(0, lastIndexB);
                                    window.history?.replaceState(null, "", newPathname+"/OnlineEvent");
                                }
                                else
                                {
                                    window.history?.replaceState(null, "", pathname+"/online-event");
                                }
                            }
                            setReload(!reload);
                        }}
                    >{t("btn.showAll")}</button>
                }
                {codeError && <p className='err-input'>{t(codeError)}</p>}
                {codeData?.state === 'Invalid' && !codeError &&<p className='err-input'>{t("err.invalid")}</p>}
                {codeData?.state === 'Expired' && !codeError &&<p className='err-input'>{t("err.expire")}</p>}
            </div>
            {filtredEvents?.map((event, idx)=>{
                const title = event.shopInfo?.title ? event.shopInfo?.title[language] ?? '<N/A>' : '<N/A>';
                const subtitle = event.shopInfo?.subtitle ? event.shopInfo?.subtitle[language] ?? '<N/A>' : '<N/A>';
                const description = event.shopInfo?.description ? event.shopInfo?.description[language] ?? undefined : undefined;

                const priceReduced = event.shopInfo?.pricereduced ? {amount: event.shopInfo?.pricereduced} : null;
                const price = {amount: event.shopInfo?.price || null};

                if (codeData && codeData?.eventId !== event.id && ['Valid', 'Used'].includes(codeData?.state)) {
                    return null
                }
                const  isFree = event.free;

                return <div key={'event-'+event.id} className="wb-grid-item wb-grid-item-6 wb-mt-4 wb-event-box" style={event.isShifted ? {background: "#E8F3FF"} : {}}>
                    <div className="wb-grid-container" style={{borderBottom: "1px solid grey", marginBottom: "10px"}}>
                        <div style={{margin: 0, padding:0}} className="wb-grid-item wb-grid-item-4">
                            <h2 style={{margin: 0, padding:0, textWrap: "nowrap"}}>{title}</h2>
                        </div>
                        {!['Valid', 'Used'].includes(codeData?.state) && <div className="wb-grid-item wb-grid-item-2" style={{textAlign: "right", bottom:0, fontSize: "18px"}}>
                            {isFree ?
                                <span>{t("free")}</span>
                                :
                                priceReduced ? 
                                    <>
                                        <span className="wb-barred-price">{formatMoney(price, language)}</span>&ensp;
                                        <span className="wb-reduced-price">{formatMoney(priceReduced, language)}</span>
                                    </>
                                    :
                                    formatMoney(price, language)
                            }
                        </div>}
                        <div style={{margin: 0, padding:0}} className="wb-grid-item wb-grid-item-4">
                            <p style={{margin: 0, padding:0}}>{subtitle} {description && <span onClick={(e) => setShowDescription(event.id)} className="wb-icon-info"></span>}</p>
                            {showDescription === event.id &&
                                <div 
                                    style={{
                                        position: "absolute",
                                        background: "white",
                                        padding: "8px",
                                        border: "1px solid grey",
                                        borderRadius: ".3rem",
                                        lineHeight: "1rem",
					maxWidth: "600px",
                                    }} 
                                    dangerouslySetInnerHTML={{__html: description}}
                                />
                            }
                        </div>
                        {!['Valid', 'Used'].includes(codeData?.state) && <div className="wb-grid-item wb-grid-item-2" style={{textAlign: "right", marginBottom: "5px"}}>
                            <button
                                title={`${event.free ? t("btn.free.tt") : t("btn.withTicket.tt")}`}
                                className="wb-button-blue"
                                onClick={event.free ? 
                                    (e) => openFreeCodePopup(e, event.id) 
                                    :
                                    (e) => openShop(e,event?.shopInfo?.shopUri)
                                }
                            >
                                {event.free ? t("btn.free") : t("btn.withTicket")}
                            </button>
                        </div>}
                    </div>

                    {event.webinarEventDates?.map((date, idx) => {
                        const isFree = event.free;
                        const isReserved = ticket?.id !== null && ticket?.eventDateId === date.id && event.id === codeData?.eventId;
                        const isStartingSoon = ticket?.startSoon ? true : false;
                        let styleDate = {backgroundColor: "#f8f8f8"};

                        if (['Valid', 'Used'].includes(codeData?.state)) {
                            styleDate = isReserved ? {boxShadow: "0 0 5px #8dd08d", backgroundColor: "#f2fff2"}: {boxShadow: "0 0 5px #306090", backgroundColor: "#f2f8ff"}
                        }

                        return <div key={'date-'+date.id} className="wb-grid-container wb-p-2" style={{...styleDate,marginBottom:"10px", borderRadius: ".3rem"}}>
                            <div className="wb-grid-item wb-grid-item-4" style={{padding:"auto"}}>
                                <div className="wb-info-date" style={{fontSize: "13px"}}>

                                    <CalendarSVG fill="#306090" name="calendar"/>
                                    <span style={{marginLeft:"5px", marginRight: "20px"}}>{localeDatetime(date.startAt, 'de', false, true)}</span>

                                    <ClockSVG fill="#306090" name="clock"/>
                                    <span style={{marginLeft:"5px", marginRight: "20px"}}>{localeDatetime(date.startAt, 'de', true, false)}</span>

                                    <UserGroupSVG fill="#306090" name="user-group"/>
                                    <span style={{marginLeft:"5px", marginRight: "20px"}}>{t("eventDate.place")} {date.freeTicketNum}</span>
                                </div>
                            </div>
                            <div className="wb-grid-item wb-grid-item-2" style={{display: "flex", justifyContent: "end", alignItems: "center"}}>
                                <div style={{float: "right"}}>

                                {isReserved ? 
                                    <div className="wb-center-hw" style={{color: "green"}}>
                                        {
                                            <>
                                                {isStartingSoon && 
                                                    <InfoSVG 
                                                        style={{cursor: "pointer"}}
                                                        name="info"
                                                        width="16"
                                                        height="16"
                                                        fill="#416389"
                                                        onClick={(e) => {
                                                            handleOpenInfoPopup(e, codeData?.methodInfo);
                                                        }}
                                                    />
                                                }
                                                {ticket?.isRevocable === true && !isStartingSoon &&
                                                    <button
                                                        title={t('btn.retract.tt')}
                                                        className="wb-btn-light-grey"
                                                        style={{paddingLeft: "8px", paddingRight: "8px"}}
                                                        //onClick={handleCancelCode}
                                                        onClick={(e) => {
                                                            e?.preventDefault();
                                                            setCancelCodeData({isOpen: true});
                                                        }}
                                                        disabled={isLoading || ticket?.isRevocable === false}
                                                    >
                                                        <CloseSVG style={{position: "relative",top:"0.5px"}} width="10" height="10" fill="#7A7A7A" name="calendar"/>
                                                        {/*t("btn.retract")*/}
                                                    </button>
                                                }
                                            
                                                <button
                                                    title={isStartingSoon ? t("btn.join.tt") : t("btn.join.tt.off", {min: 10})}
                                                    className="wb-button-blue"
                                                    style={{marginLeft: "5px"}}
                                                    onClick={(e) => {
                                                        e?.stopPropagation();
                                                        e?.preventDefault();
                                                        const link = codeData?.methodInfo?.link;
                                                        const code = codeData?.methodInfo?.code;
                                                        const pin = codeData?.methodInfo?.pin;
                                                        window.open(link?.replace('{connect_code}', code)?.replace('{connect_pin}', pin), '_blank');
                                                        EVENTS_API.joinEventDate({eventDateId: ticket.eventDateId, ticketId: ticket.id})
                                                    }}
                                                    disabled={isLoading || !isStartingSoon}
                                                >
                                                    {t("btn.join")}
                                                </button>
                                            </>
                                        }
                                    </div>
                                :
                                codeData?.eventId === event.id && [date.id, null].includes(codeData?.eventDateId) && ['Valid', 'Used'].includes(codeData?.state) ?
                                    <PopupReserve 
                                        data={{
                                            btnOpen: {ref: popupBtnRef, txt:"btn.book", tt:"btn.book.tt", openShop:openShop},
                                            title:"book.form",
                                            body: {p: "book.form.txt"},
                                            event:{
                                                title: event.shopInfo?.title ? event.shopInfo?.title[language] ?? '<N/A>' : '<N/A>',
                                                subtitle: event.shopInfo?.subtitle ? event.shopInfo?.subtitle[language] ?? '<N/A>' : '<N/A>',
                                                date:date.startAt,
                                                free:event.free,
                                                isAlreadyStart:date.alreadyStarted,
                                                startInNext24Hours: date.startInNext24Hours,
                                                notifyPreHours: event.notifyPreHours
                                            }
                                        }}
                                        language={language}
                                        setTicket={setTicket}
                                        code={code}
                                        codeData={codeData}
                                        eventDateId={date.id}
                                        ticket={ticket}
                                        disabled={
                                            isLoading ||
                                            ticket?.isRevocable ||
                                            codeData?.state !== 'Valid' ||
                                            codeData?.eventId !== event.id
                                        }
                                        reload={() => setReload(!reload)}
                                    />
                                    :
                                    codeData?.eventId === event.id && ['Used'].includes(codeData?.state) ?
                                    <button
                                        title={t("requestCode.open.tt")}
                                        className="wb-btn-light-blue"
                                        style={{marginLeft: "5px"}}
                                        onClick={(e) => {
                                            e?.stopPropagation();
                                            e?.preventDefault();
                                            setBuyNewCodeData({...buyNewCodeData, isOpen: true, isFree, event})
                                        }}
                                        disabled={isLoading}
                                    >
                                        {isFree ? t("requestCode.free.btn") : t("requestCode.buy.btn")}
                                    </button>
                                    :
                                    <></>
                                }
                                </div>
                            </div>
                    </div>
                    })}
                </div>
            })}
        </div>
        {sessionInfo &&
            <PopupInfo data={sessionInfo} close={closePopupInfo} info={POPUPI_NFO}/>
        }

        <PopupFreeCode data={sessionInfo} popupBtnRef={popupFreeCodeBtnRef} />

        {buyNewCodeData?.isOpen && (
            <div name="popupBuyCodeOverlay" className="wb-popup">
                <div className="wb-popup-content">
                    <div style={{position: "relative"}}>
                        <span onClick={() => setBuyNewCodeData({isOpen: false})} className="wb-close-x">&#10005;</span>
                    </div>
                    <h2>{buyNewCodeData.isFree ? t("requestCode.free") : t("requestCode.buy")}</h2>
                    <p style={{fontSize: "13px"}}>{buyNewCodeData.isFree ? t("requestCode.free.txt") : t("requestCode.buy.txt")}</p>
                    
                    <div className='wb-grid-container wb-mb-2 wb-mt'>
                        <div className="wb-grid-item-6" style={{fontSize: "13px"}}>
                            <button 
                                className='wb-btn-light-grey'
                                style={{float: "left"}}
                                onClick={() => setBuyNewCodeData({isOpen: false})}
                            >{t("book.form.btn.cancel")}</button>

                            <button
                                title={buyNewCodeData.isFree ? t("requestCode.free.btn.tt") : t("requestCode.buy.btn.tt")}
                                className='wb-button-blue'
                                style={{float: "right"}}
                                onClick={(e) => {
                                    if (buyNewCodeData.isFree) {
                                        openFreeCodePopup(e, buyNewCodeData?.event?.id)
                                    }else{
                                        openShop(e, buyNewCodeData?.event?.shopInfo?.shopUri);
                                    }
                                    setBuyNewCodeData({isOpen: false});
                                }}
                            >
                                {buyNewCodeData.isFree ? t("requestCode.free.btn") : t("requestCode.buy.btn")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {cancelCodeData?.isOpen && (
            <div name="popupCancelCodeOverlay" className="wb-popup">
                <div className="wb-popup-content">
                    <div style={{position: "relative"}}>
                        <span 
                            className="wb-close-x"
                            onClick={()=>{setCancelCodeData({isOpen: false})}} 
                        >&#10005;</span>
                    </div>
                    <h2>{t("retract")}</h2>
                    {!cancelCodeData?.response && <>
                        <p style={{fontSize: "13px"}} dangerouslySetInnerHTML={{__html: t("retract.txt", {count: codeData.retractFree})}} />
                        <p style={{fontSize: "13px"}} dangerouslySetInnerHTML={{__html: t("retract.rest", {count: codeData.retractFree})}} />

                        {cancelCodeData.err && <p className='err-input'>{t(cancelCodeData.err)}</p>}
                        
                        <div className='wb-grid-container wb-mb-2 wb-mt'>
                            <div className="wb-grid-item-6" style={{fontSize: "13px"}}>
                                <button 
                                    className='wb-btn-light-grey'
                                    style={{float: "left"}}
                                    onClick={()=>{setCancelCodeData({isOpen: false})}} 
                                >{t("book.form.btn.cancel")}</button>

                                <button
                                    title={t("retract.btn.tt")}
                                    className='wb-button-blue'
                                    style={{float: "right"}}
                                    onClick={(e) => {
                                        handleCancelCode(e);
                                    }}
                                >
                                    {t("retract.btn")}</button>
                            </div>
                        </div>
                    </>}
                    {cancelCodeData.response && <>
                            <div className="wb-center-hw">
                            <img
                                src={process.env.PUBLIC_URL + LetterGif}
                                className="wb-letter-img"
                                alt="Mail Icon"
                                loading="lazy"
                            />
                            </div>
                            <p className='wb-mt-4' dangerouslySetInnerHTML={{__html: t("retract.ok", {email: ticket?.email})}} />
                            <button className='wb-button-blue wb-mt-2' style={{float: "right"}} onClick={()=>{setCancelCodeData({isOpen: false})}} >{t("btn.close")}</button>
                        </>
                    }
                </div>
            </div>
        )}
        {['Valid', 'Used'].includes(codeData?.state) && codeData?.hasEvent === false && <p>{t("err.noEvent")}</p>}
        {
            ((['Valid', 'Used'].includes(codeData?.state) && codeData?.hasEvent === true && codeData?.hasEventDate === false) || filtredEvents?.length < 1) 
            
            && 

           <div className="wb-grid-item wb-grid-item-6 wb-mt-4">
                <div className="wb-grid-container" style={{marginBottom: "10px"}}>
                    <div style={{margin: 0, padding:0}} className="wb-grid-item wb-grid-item-4">
                        <h3 style={{margin: 0, padding:0, textWrap: "nowrap"}}>{t("err.listEmpty")}</h3>
                    </div>
                </div>

                {/*<div className="wb-grid-container wb-p-2" style={{marginBottom:"10px", borderRadius: ".3rem"}}>
                        
                </div>*/}
            </div>
        }
    </>
}

export default EventList;